const PIXELS_PER_SECOND = 100;

const SPARE_SETS = 1;

const lines = new Map();
const byProbe = new Map();

function measure(record) {
    const { section, probe } = record;

    const previous = section.style.contentVisibility;
    section.style.contentVisibility = 'visible';
    const setWidth = probe.getBoundingClientRect().width;
    const target = Math.max(
        section.getBoundingClientRect().width,
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0
    );
    section.style.contentVisibility = previous;

    return { setWidth, target };
}

function build(record) {
    const { wrap, nodes } = record;
    const { setWidth, target } = measure(record);
    if (setWidth <= 0) return;

    const sets = Math.ceil((target + 1) / setWidth) + SPARE_SETS;

    const group = document.createElement('div');
    group.className = 'blog__running-line-group';
    for (let i = 0; i < sets; i++) {
        nodes.forEach(node => {
            const copy = node.cloneNode(true);
            if (i > 0) {
                copy.dataset.clone = '1';
                copy.setAttribute('aria-hidden', 'true');
            }
            group.appendChild(copy);
        });
    }

    const twin = group.cloneNode(true);
    twin.setAttribute('aria-hidden', 'true');
    twin.querySelectorAll('.blog__running-line-text').forEach(node => {
        node.dataset.clone = '1';
    });

    wrap.classList.remove('is-running');
    wrap.textContent = '';
    wrap.appendChild(group);
    wrap.appendChild(twin);
    wrap.style.animationDuration = `${(setWidth * sets) / PIXELS_PER_SECOND}s`;
    wrap.classList.add('is-running');

    record.setWidth = setWidth;
}

function buildAll() {
    lines.forEach(build);
}

const observer = typeof ResizeObserver === 'function'
    ? new ResizeObserver(entries => {
        entries.forEach(entry => {
            const record = byProbe.get(entry.target);
            if (!record) return;

            const width = entry.contentRect.width;
            if (width <= 0 || Math.abs(width - record.setWidth) < 1) return;

            build(record);
        });
    })
    : null;

function createProbe(section, nodes) {
    const probe = document.createElement('div');
    probe.className = 'blog__running-line-probe';
    probe.setAttribute('aria-hidden', 'true');
    nodes.forEach(node => probe.appendChild(node.cloneNode(true)));
    section.appendChild(probe);
    return probe;
}

function initRunningLines() {
    document.querySelectorAll('.blog__running-line-wrap').forEach(wrap => {
        if (wrap.dataset.runningLineReady === '1') return;

        const section = wrap.closest('.blog__running-line') || wrap.parentElement;
        const originals = wrap.querySelectorAll('.blog__running-line-text:not([data-clone])');
        const nodes = Array.from(originals.length ? originals : wrap.querySelectorAll('.blog__running-line-text'))
            .map(node => node.cloneNode(true));
        if (nodes.length === 0) return;

        wrap.dataset.runningLineReady = '1';

        const record = {
            wrap,
            section,
            nodes,
            probe: createProbe(section, nodes),
            setWidth: 0,
        };

        lines.set(wrap, record);
        byProbe.set(record.probe, record);
        build(record);

        if (observer) observer.observe(record.probe);
    });
}

initRunningLines();

if (!document.documentElement.dataset.runningLineBound) {
    document.documentElement.dataset.runningLineBound = '1';

    if (document.fonts) {
        document.fonts.ready.then(buildAll);
    }

    let lastWidth = window.innerWidth;
    let timer;
    window.addEventListener('resize', () => {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        clearTimeout(timer);
        timer = setTimeout(buildAll, 200);
    });
}
